import React from 'react'
import styled from 'styled-components';
import { lightThemeColors } from '../../assets/style/colors';
import { AnimatePresence, motion } from 'framer-motion';
import CardWithNumber from '../generic/CardWithNumber';
import UsecaseCard from './UsecaseCard';
import AnimatedTextButton from '../generic/AnimatedTextButton';
import { useNavigate } from 'react-router-dom';


const UsecaseData = () => {
    const navigate = useNavigate();
    const howItWorksItems = [

        {
            title: "Clearly Track What Works",
            subtitle: "User Acquisition & Attribution",
            description: "Stop guessing and confidently measure campaign impact with accurate attribution, clear performance insights, and smarter ad spend optimization.",
            highlight: "Higher installs, lower cost per acquisition, and clearer insights.",
            seeMore: () => navigate("/measure")
        },
        {
            title: "Seamless Experiences from First Click",
            subtitle: "Frictionless Onboarding & Journeys ",
            description: "Eliminate broken paths and confusion with smart deep links that guide users to the right content, continue journeys post-install, and stay fully editable even after launch.",
            highlight: "Boost activation, reduce drop-offs, and drive more conversions.",
            seeMore: () => navigate("/engagement")

        },
        {
            title: "Same Message Across Every Platform",
            subtitle: "Cross-Platform Engagement",
            description: "Keep users engaged without overwhelm using tailored in-app, push, and inbox messages—targeted by user type and platform, all managed from one simple dashboard.",
            highlight: "Increased user engagement, retention, and lifetime value.",
            seeMore: () => navigate("/messaging")

        },
        {
            title: "Amplify Word-of-Mouth Marketing",
            subtitle: "Referral & Advocacy Tracking",
            description: "Turn users into your best marketers by easily tracking referrals, identifying top ambassadors, and driving sustainable growth through user advocacy.",
            highlight: "More referrals, boost organic growth, and reduce acquisition costs.",
            seeMore: () => navigate("/app-growth")

        },
        {
            title: "Bring Back Users Effectively",
            subtitle: "Reactivation & Retention",
            description: "Bring inactive users back by tracking reactivation success, delivering personalized messages, and quickly optimizing what works.",
            highlight: "Higher user retention rates and improved reactivation success.",
            seeMore: () => navigate("/increase-engagement")

        },
        {
            title: "Clear Insights, Better Decisions",
            subtitle: "Campaign & Link Performance Analysis",
            description: "Get real-time insights to guide smarter decisions—compare campaigns, track deep link engagement, and shift focus to what drives results.",
            highlight: "Better decisions, boost ROI, and maximize campaign performance.",
            seeMore: () => navigate("/measure")

        },
        {
            title: "Deliver What Users Actually Want",
            subtitle: "Personalized User Experiences",
            description: "Boost satisfaction and retention with personalized, seamless experiences—show relevant content, streamline onboarding, and trigger timely messages based on user behavior.",
            highlight: "Happier users, deeper engagement, and higher lifetime value.",
            seeMore: () => navigate("/analyse")

        },



    ]
    return (
        <FullPageContainer >
            <Container>
                <ItemsWrapper>
                    {howItWorksItems.map((item, index) => (
                        <UsecaseCard
                            key={index}
                            title={item.title}
                            subtitle={item.subtitle}
                            description={item.description}
                            highlight={item.highlight}
                            seeMore={item.seeMore}
                        />
                    ))}
                    <LastItem>
                        <AnimatedTextButton
                            onClick={() => navigate("/app-growth")}
                            text={"See all features"}
                            textStyle={{ fontSize: "18px" }}
                            style={{

                                color: lightThemeColors.lightColor,
                                borderBottom: `1px solid ${lightThemeColors.lightColor}`
                            }}
                            textColor={lightThemeColors.lightColor}
                        />
                    </LastItem>

                </ItemsWrapper>
            </Container>
        </FullPageContainer>
    )
}

export default UsecaseData


const FullPageContainer = styled.div`
  display: flex;
  width: 100%;
  background: ${lightThemeColors.darkColor};
  position: relative;
`;

const Container = styled.div`
  width: 100%;
  max-width: 1512px;
  margin-left: auto;
  margin-right: auto;
  z-index: 1;
  display: flex;
  flex-direction: column;
padding:100px 80px;
  gap: 100px;
  @media (max-width: 990px) {
    padding: 20px;
    gap: 30px;
  }
`;

const ItemsWrapper = styled(motion.div)`
 display: grid;
  grid-template-columns: repeat(auto-fill, minmax(450px, 1fr));
  gap: 40px; 
height:100%;

@media(max-width:990px){
display:flex;
flex-direction:column;
}
`
const LastItem = styled.div`
display:flex;
align-items:center;
justify-content:center;
`